import { render } from "./resultcopy.vue?vue&type=template&id=59c42d15&scoped=true"
import script from "./resultcopy.vue?vue&type=script&lang=js"
export * from "./resultcopy.vue?vue&type=script&lang=js"

import "./resultcopy.vue?vue&type=style&index=0&id=59c42d15&lang=scss&scoped=true"

import exportComponent from "D:\\project\\websites\\zxr_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c42d15"]])

export default __exports__